import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ContactForm from '../common/ContactForm';

const Contact: React.FC = () => {
  const links = [
    {
      name: "GitHub",
      url: "https://github.com/Cuzzo01",
      icon: "📁",
      description: "View my code and projects"
    },
    {
      name: "LinkedIn", 
      url: "https://www.linkedin.com/in/nickmarcuzzo/",
      icon: "💼",
      description: "Professional Profile"
    },
    {
      name: "Resume",
      url: "/assets/resume/2025-public.pdf",
      icon: "📄",
      description: "Download my resume"
    }
  ];

  return (
    <section id="contact" className="py-5">
      <Container>
        <h2 className="text-center mb-5">Get In Touch</h2>
        <Row className="justify-content-center">
          <Col lg={8}>
            <p className="text-center lead mb-4">
              I'm always interested in discussing new opportunities, 
              collaborating on interesting projects, or just talking tech.
            </p>
            
            <Row className="mb-5">
              <Col lg={12}>
                <ContactForm formId="mnnzgpvn" />
              </Col>
            </Row>
            
            <h4 className="text-center mb-4">Links & Resume</h4>
            <Row className="g-3">
              {links.map((link, index) => (
                <Col md={4} key={index}>
                  <Button
                    variant="outline-light"
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-100 p-3 text-start d-flex align-items-center"
                    style={{ minHeight: '80px' }}
                  >
                    <span className="fs-3 me-3">{link.icon}</span>
                    <div>
                      <div className="fw-bold">{link.name}</div>
                      <small className="text-muted">{link.description}</small>
                    </div>
                  </Button>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
